// FR-W12: out-of-snaps state for the dormant FR-S22 quota. resetsAt renders
// as the viewer's local time; personal-archive voice, no upsell pressure.
interface QuotaStateProps {
  resetsAt?: string;
  onDismiss: () => void;
}

export function QuotaState({ resetsAt, onDismiss }: QuotaStateProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      <span aria-hidden className="text-3xl">📷</span>
      <h3 className="m-0 text-base font-semibold text-foreground">You&rsquo;re out of snaps for today</h3>
      <p className="m-0 max-w-sm text-sm text-muted-foreground">
        Your snaps refresh {resetsAt ? `at ${new Date(resetsAt).toLocaleString()}` : 'soon'}.
        Everything you&rsquo;ve already stashed is safe on your board.
      </p>
      <button
        type="button"
        onClick={onDismiss}
        className="rounded-full bg-primary px-5 py-2.5 font-semibold text-primary-foreground"
      >
        Back to STASH Board
      </button>
    </div>
  );
}
